import { render } from "./BackendPagination.vue?vue&type=template&id=15aac8c6"
import script from "./BackendPagination.vue?vue&type=script&lang=js"
export * from "./BackendPagination.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__